/* BLOG TEMPLATE JS */

const blogCategories = document.querySelector('.blog-categories-bar') || false;

if (blogCategories) {
  if (window.innerWidth < 1025) {
    const categoryDropdown = blogCategories.querySelector(
      '.blog-category-dropdown-item'
    );

    categoryDropdown.addEventListener('click', (e) => {
      e.target.classList.contains('active')
        ? e.target.classList.remove('active')
        : e.target.classList.add('active');

      const categoryItems = blogCategories.querySelectorAll(
        '.blog-category-item'
      );
      categoryItems.forEach((item) => {
        if (e.target.classList.contains('active')) {
          item.style.display = 'initial';
        } else {
          item.style.display = 'none';
        }
      });
    });
  }
}
